const BASE = Date.UTC(2000, 0, 1);
const ORD_2000 = 730120;

export const ordToEarth = (ord) => {
  const d = new Date(BASE + (Math.round(ord) - ORD_2000) * 864e5);
  return Number.isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
};
export const earthToOrd = (s) => {
  const t = Date.parse(`${s}T00:00:00Z`);
  return Number.isNaN(t) ? null : Math.round((t - BASE) / 864e5) + ORD_2000;
};

export const nth = (n) => {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const KINDS = ["holiday", "birthday", "anniversary", "festival", "season", "other"];
export const RECUR_TYPES = [
  ["yearly", "Every year on a date"], ["nth_weekday", "Nth weekday of a month"], ["once", "Once (single date)"],
  ["every_n_days", "Every N days"], ["moon_phase", "Every new / full moon"],
];
const NTH = { 1: "1st", 2: "2nd", 3: "3rd", 4: "4th", 5: "5th", "-1": "last" };
export const NTH_OPTIONS = Object.entries(NTH);

export function describeRecurrence(r = {}, cal) {
  const mn = cal?.month_names?.[r.month] ?? `Month ${r.month + 1}`;
  const wd = cal?.weekday_names?.[r.weekday] ?? `weekday ${r.weekday + 1}`;
  switch (r.type) {
    case "once": return `${r.day} ${mn} ${r.year}`;
    case "nth_weekday": return `${NTH[r.nth] || r.nth} ${wd} of ${mn}`;
    case "every_n_days": return `Every ${r.interval} days from ${r.day} ${mn} ${r.year}`;
    case "moon_phase": return `Every ${r.phase} ${cal?.moons?.[r.moon]?.name || "moon"}`;
    case "computed": return `Computed (${(r.fn || "").replace(/_/g, " ")})`;
    default: return `Every ${r.day} ${mn}${r.start_year != null ? ` since ${r.start_year}` : ""}`;
  }
}

export const eventSuffix = (e) => {
  const parts = [];
  if (e.kind === "birthday" && e.years > 0) parts.push(`turns ${e.years}`);
  else if (e.years > 0) parts.push(nth(e.years));
  if (e.duration > 1 && e.part) parts.push(`${e.part}/${e.duration}`);
  return parts.length ? ` · ${parts.join(" · ")}` : "";
};
